import ZlbConfirm from '@/components/ZlbConfirm';
import {
  deleteBudgetQuota,
  fetchBudgetQuotaList,
  fetchEconomyClassifyList,
  fetchStatisticsAmountinfo,
  getBudgetQuota,
  getBudgtUsedRecord,
  getProjectList,
  saveBudgetQuota,
  transferredQuota,
} from '../services';

const responseErrorHandle = res => {
  const { success, message } = res;
  if (!success) {
    ZlbConfirm({
      title: message,
      showOkBtn: false,
      cancelText: '知道了',
    });
  }
  return success;
};

export default {
  namespace: 'budgetQuota',
  state: {
    reimburseTypeList: [],
    detail: {},
  },
  effects: {
    /**
     * 预算额度列表
     */
    *getBudgetQuotaList({ payload }, { call }) {
      const res = yield call(fetchBudgetQuotaList, payload);
      responseErrorHandle(res);
      return res;
    },
    /**
     * 经济分类列表
     */
    *getEconomyClassifyList({ payload }, { call }) {
      const res = yield call(fetchEconomyClassifyList, payload);
      responseErrorHandle(res);
      return res;
    },
    /**
     * 查询统计指标金额
     */
    *getStatisticsAmountinfo({ payload }, { call }) {
      const res = yield call(fetchStatisticsAmountinfo, payload);
      responseErrorHandle(res);
      return res;
    },
    /**
     * 生成预算额度
     */
    *createBudgetQuota({ payload }, { call }) {
      const res = yield call(saveBudgetQuota, payload);
      responseErrorHandle(res);
      return res;
    },
    /**
     * 删除预算额度
     */
    *deleteBudget({ payload }, { call }) {
      const res = yield call(deleteBudgetQuota, payload);
      // responseErrorHandle(res);
      return res;
    },

    /**
     * 预算额度详情
     */
    *getBudgetQuotaDetail({ payload }, { call, put }) {
      const res = yield call(getBudgetQuota, payload);
      responseErrorHandle(res);
      yield put({
        type: 'update',
        payload: {
          detail: res.result || [],
        },
      });
      return res;
    },
    /**
     * 结转预算额度
     */
    *transferredQuota({ payload }, { call }) {
      const res = yield call(transferredQuota, payload);
      responseErrorHandle(res);
      return res;
    },
    /**
     * 查询预算使用记录
     */
    *getBudgtUsedRecord({ payload }, { call }) {
      const res = yield call(getBudgtUsedRecord, payload);
      responseErrorHandle(res);
      return res;
    },
    /**
     * 查询预算项目
     */
    *getProjectList({ payload }, { call }) {
      const res = yield call(getProjectList, payload);
      responseErrorHandle(res);
      return res;
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
